import type { TcsRecommendationRepository } from "../repositories/TcsRecommendationRepository";
import type { TcsRecommendationEntity } from "../entities/TcsRecommendationEntity";

export class GetTcsRecommendationByJobIdUseCase {
  constructor(private repository: TcsRecommendationRepository) {}

  async execute(jobId: string): Promise<TcsRecommendationEntity | null> {
    if (!jobId || jobId.trim() === "") {
      return null;
    }
    return this.repository.getByJobId(jobId.trim());
  }
}
